export default {
  computed: {
    canEdit() {
      return (
        this.election.status == "pending"
      );
    }
  }
};
